import Header from "../components/Header";
import { useTranslation } from "react-i18next";

const ThongBaoTinTuc = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
    <div className="wrapper">
      <div className="container-web gioithieusanpham bgnew">
        <Header title={t("Thông báo tin tức")} />
        <main>
          <div className="d-flex justify-content-between align-items-center" style={{ fontSize: 13 }}>
            <div
              className="w-100 text-center"
              style={{
                borderBottom: "2px solid #eecb77",
                color: "#eecb77",
                height: 44,
                alignContent: "center",
              }}
            >
              {t("Tin tức")}
            </div>
            <div
              className="w-100 text-center"
              style={{
                borderBottom: "2px solid #eecb77",
                color: "#eecb77",
                height: 44,
                alignContent: "center",
              }}
            >
              {t("Thông báo")}
            </div>
          </div>
          <div className="px-3 pt-2" style={{ fontSize: 13 }}>
            <div className="p-5 text-center">{t("Không có dữ liệu")}</div>
            {/* <div className="d-flex justify-content-between align-items-center py-2">
              <div className="d-flex align-items-center gap-1">
                <i className="fa-solid fa-volume-high"></i>
                <span>Nạp tiền vào tài khoản</span>
              </div>
              <div>17-02-2025</div>
            </div> */}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ThongBaoTinTuc;
